export const STANDARD_FORMAT_STRING_LENGTH = 16;
export const STANDARD_FORMAT_STRING_MAX_LENGTH = 32;
export const STANDARD_CUSTOM_FIELD_NAME_MAX_LENGTH = 20;
export const CREATE_CUSTOM_FIELD_NAME_MAX_LENGTH = 80;
export const STANDARD_FORMAT_STRING_MIN_LENGTH = 3;
